import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import { Input } from '../../../../../../components/common-inputs';
import CommonDatePicker from '../../../../../../components/common-date-picker/CommonDatePicker';

import scss from '../../Steps.module.scss';

function BugReportFields() {
  const { t } = useTranslation('contact');

  const handleChangeBugTime = (value, input) => {
    input.onChange(value);
  };

  return (
    <>
      <Field name='bugProjectName' autoComplete='bugProjectName'>
        {({ input }) => (
          <WithLabel
            label={t('bugProjectName')}
            variant={LABEL_STYLES.COLUMN}
            tip={t('projectNameWhereBugOccurred')}
            isBold
            isTwoDots>
            <Input size='sm' formProps={input} placeholder={t('projectName')} />
          </WithLabel>
        )}
      </Field>

      <Field name='bugTime' autoComplete='bugTime'>
        {({ input }) => (
          <WithLabel
            label={t('bugTime')}
            variant={LABEL_STYLES.COLUMN}
            isBold
            isTwoDots
            extraClassName={scss.datePicker}
            tip={t('approximateTimeWhenBugOccurred')}>
            <CommonDatePicker
              showTimeSelect
              dateFormat='dd.MM.yyyy h:mm'
              selected={input.value}
              onChange={(value) => handleChangeBugTime(value, input)}
              placeholder={t('time')}
            />
          </WithLabel>
        )}
      </Field>
    </>
  );
}

export default BugReportFields;
